/** Prepare a browser copy without holding a video request through transcoding. */
export const FILE_VIDEO_PATTERN = /\.(mp4|webm|mkv|avi|flv|mov)$/i;

export async function prepareFilePreview(url: string, signal: AbortSignal, onStatus: (text: string) => void, retry = false): Promise<void> {
  const deadline = Date.now() + 10 * 60 * 1000;
  let first = true;
  while (Date.now() < deadline) {
    signal.throwIfAborted();
    const controller = new AbortController();
    const abort = () => controller.abort();
    signal.addEventListener('abort', abort, { once: true });
    const timer = setTimeout(abort, 15000);
    let response: Response;
    let state: { status?: string; message?: string; error?: string } | undefined;
    try {
      const preparedUrl = new URL(url, window.location.href);
      preparedUrl.searchParams.set('prepare', '1');
      if (retry && first) preparedUrl.searchParams.set('retry', '1');
      response = await fetch(preparedUrl.href, {
        credentials: 'same-origin', signal: controller.signal,
      });
      const payload: unknown = await response.json().catch(() => undefined);
      if (payload && typeof payload === 'object' && 'data' in payload && payload.data && typeof payload.data === 'object') {
        const data = payload.data;
        state = {
          status: 'status' in data && typeof data.status === 'string' ? data.status : undefined,
          message: 'message' in data && typeof data.message === 'string' ? data.message : undefined,
          error: 'error' in data && typeof data.error === 'string' ? data.error : undefined,
        };
      }
    } finally {
      clearTimeout(timer);
      signal.removeEventListener('abort', abort);
    }
    first = false;
    if (!response.ok) throw new Error(typeof state?.error === 'string' ? state.error : 'Не удалось подготовить превью. Оригинал можно скачать.');
    if (state?.status === 'ready') return;
    if (state?.status === 'error') throw new Error(state.message || 'Не удалось подготовить превью. Оригинал можно скачать.');
    if (!['queued', 'processing', 'busy'].includes(state?.status || '')) throw new Error('Сервер не подтвердил подготовку превью.');
    onStatus(state?.status === 'processing' ? 'Готовим видео для просмотра…' : 'Видео ожидает подготовки…');
    await new Promise<void>((resolve, reject) => {
      const onAbort = () => { clearTimeout(wait); reject(new DOMException('Aborted', 'AbortError')); };
      const wait = setTimeout(() => { signal.removeEventListener('abort', onAbort); resolve(); }, 1500);
      signal.addEventListener('abort', onAbort, { once: true });
      if (signal.aborted) onAbort();
    });
  }
  throw new Error('Подготовка заняла слишком много времени. Попробуйте позже или скачайте оригинал.');
}
